import ReactDOM from 'react-dom'

export const renderPortal = (renderDropDown: any): React.ReactPortal => {
  return ReactDOM.createPortal(renderDropDown && renderDropDown(), document.body)
}
